<template lang="pug">
div
  slot(name="activator" :toggle="toggle")
    v-btn(small color='primary' 
      @click="toggle" 
      :disabled="disabled"
      outlined
    ) Remove exam requests
  v-dialog(v-model="showing" scrollable max-width=800)
    v-card(data-test="c-exchange-body")
      v-card-title(data-test="c-exchange-title") Remove exam requests
      v-card-text
        reservations(:formErrors="formErrors" ref="reservations" addText="add exam"
          :getExamLocation="getExamLocation"
          :getCourseLocation="getCourseLocation"
          :model="model"
          :avaliableSlots="false"
          :onHoldShowing="false"
          :showCommentFields="false"
        )
          template(v-slot:form="form")
            slotsProvider(v-slot="slots" :key="showing")
              reservationSlotsProvider(
                :examDate="form.item.examDate"
                :examLocation="form.item.location"
                @change="slots.loadList"
                v-slot="slotsCheck"
              )
                list(
                  v-if="Object.keys(slots.model.list).length"
                  :model="slots.model"
                  :loading="slots.loading"
                  :pagination="slots.pagination"
                  @change:location="slotsCheck.checkDataToLoadList"
                  @change:examDate="slotsCheck.checkDataToLoadList"
                  v-show="!slots.loadingErr"
                )

        div.text-center.mt-3
        
      v-card-actions
        v-spacer
        v-btn(color="error" text @click="toggle") Close
        v-btn(color="success" data-test="c-exchange-submit" text @click="submit" :loading="loading") Remove exams
</template>
<script>
import errorsMixin from '@/mixins/errors.mixin'
import FormErrors from "@/util/form-errors"
import { mapActions } from 'vuex'
import Model from "../core/candidates-reservation-model"
import { API_ATTRIBUTES_NESTED } from '../core/candidates-const'
import CandidateRequestsValidator from '../core/models/validation/CandidateRequestsValidator'
import CourseModel from '../../../models/courseModel'

export default {
  mixins: [errorsMixin],
  props: {
    disabled: Boolean,
    activeItems: Array,
    defaultCourse: Object
  },
  data: () => ({
    showing: false,
    loading: false,
    formErrors: new FormErrors(),
    model: new Model(),
  }),

  inject: ['svc'],

  methods: { 
    ...mapActions({
      getExamLocation: 'crmExamLocation/list',
      getCourseLocation: 'crmCourseCities/list'
    }),
    toggle() {
      this.showing = !this.showing
    },

    Svc() {
      return this.svc()
    },

    submit() {
      this.model.requests = this.$refs.reservations.requests
      this.formErrors.resetFields()
      let exchangeRequests = this.model._getRemoveRequestsApiDataBy(this.$refs.reservations.requests)
      new CandidateRequestsValidator(this.model.requests, this.formErrors, 'requests').validate()
      if (exchangeRequests.length) {
        let fieldsNotFilled = Object.values(exchangeRequests[0]).every(field => !field)
        if(fieldsNotFilled) {
          this.$notify({text: 'Please, fill fields before sent', type: 'error'})
          return
        }
      }
      if(!this.formErrors.isValid()) {
        this.$notify({text: 'Invalid fields', type: 'error'})
        return
      }
      this.send()
    },

    async send() {
      try {
        this.loading = true
        let ids = this.activeItems.map(item => item.ID)
        let exchangeRequests = this.model._getRemoveRequestsApiDataBy(this.$refs.reservations.requests)
        await this.svc().removeRequests({ids: ids, exchangeRequests: exchangeRequests})
        this.$notify({text: 'Bulk remove exams request sended', type: 'success'})
        this.toggle()
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_CRM,
          formErrors: this.formErrors, 
          apiAttributes: {
            exams: 'requests'
          },
          nestedErrors: API_ATTRIBUTES_NESTED
        });
      }
      finally {
        this.loading = false
      }
    },
  },

  watch: {
    showing(isShowing) {
      if(!isShowing) {
        this.model = new Model()
        this.$refs.reservations.resetRequests()
      } else if(this.defaultCourse && this.defaultCourse.item) {
        let course = new CourseModel({
          id: this.defaultCourse.item.ID,
          date: this.defaultCourse.item._date,
          name: this.defaultCourse.item.name,
          city: this.defaultCourse.item.city
        })
        this.model.requests[0].course = course;
        this.$refs.reservations && this.$refs.reservations.setRequests();
      }
    }
  },

  components: {
    reservations: () => import('./item/CanditeReservations.vue'),
    list: () => import('@/app/admin/modules/slots/components/SlotsList.vue'),
    slotsProvider: () => import('@/app/admin/modules/slots/components/SlotsProvider.vue'),
    reservationSlotsProvider: () => import('./CandidatesReservationSlotsProvider.vue')
  }
}
</script>
